// extracted by mini-css-extract-plugin
export default {"returning":"Ux-z","image":"Vx-z","boxNum":"Wx-z","boxedItems":"Xx-z","buttons":"Yx-z","disabled":"Zx-z"};